var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecruitmentProcessBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1289 523.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#edeefc;}.b{fill:#acaae2;opacity:0.25;isolation:isolate;}.c{fill:#00a7ff;}.d{fill:#d2e4ff;}.e{fill:#e9a4b3;}.f{fill:#d998a9;}.g{fill:#22d696;}.h{fill:#040227;}.i{fill:none;stroke:#c9798d;stroke-miterlimit:10;}.j{fill:#fff;}.k{fill:#707070;opacity:0.17;}.l{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 91.512,
    width: 1289,
    height: 432,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 -59.988)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, -4.5, 59.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1280,
    height: 423,
    rx: 4,
    transform: "translate(4.5 95.01)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.773 6.012)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M604.359,1195.933a35.956,35.956,0,0,1-7.945-1.181,23.254,23.254,0,0,0-29.609,21.35l-1.686,47.877a23.119,23.119,0,0,0,22.288,23.916l47.524,1.676a22.913,22.913,0,0,1,21.713,28.208,36.093,36.093,0,0,0-1.132,7.771c-.832,23.615,21.58,43.57,50.052,44.571s52.227-17.332,53.062-40.936a35.875,35.875,0,0,0-.583-7.833,22.917,22.917,0,0,1,23.647-26.6l47.511,1.668a23.12,23.12,0,0,0,23.913-22.286l1.675-47.522A22.921,22.921,0,0,1,883,1204.9a35.675,35.675,0,0,0,7.729,1.127c23.612.831,43.566-21.577,44.57-50.05s-17.33-52.228-40.94-53.063a35.826,35.826,0,0,0-7.792.573,22.918,22.918,0,0,1-26.6-23.638l1.674-47.52a23.121,23.121,0,0,0-22.288-23.917l-48.1-1.694a23.168,23.168,0,0,1-21.273-29.763,35.879,35.879,0,0,0,1.356-8.6c.831-23.609-21.578-43.566-50.052-44.57s-52.227,17.332-53.064,40.94a36,36,0,0,0,.748,8.67,23.165,23.165,0,0,1-23.315,28.192l-48.1-1.692a23.119,23.119,0,0,0-23.916,22.288l-1.667,47.365a23.278,23.278,0,0,0,27.4,24.012,36.012,36.012,0,0,1,8.617-.738c23.612.83,41.943,24.587,40.94,53.063S627.971,1196.762,604.359,1195.933Z",
    transform: "translate(300.173 -843.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M586.194,1175.9a35.942,35.942,0,0,1-7.945-1.179,23.248,23.248,0,0,0-29.607,21.349l-1.687,47.877a23.12,23.12,0,0,0,22.288,23.917l47.524,1.677a22.913,22.913,0,0,1,21.713,28.208,36.1,36.1,0,0,0-1.131,7.771c-.833,23.615,21.578,43.57,50.051,44.57s52.228-17.33,53.063-40.934a35.889,35.889,0,0,0-.584-7.834,22.92,22.92,0,0,1,23.647-26.6l47.511,1.667a23.12,23.12,0,0,0,23.915-22.286l1.673-47.52a22.923,22.923,0,0,1,28.208-21.716,35.614,35.614,0,0,0,7.727,1.127c23.613.831,43.567-21.576,44.572-50.05s-17.332-52.228-40.94-53.065a35.841,35.841,0,0,0-7.793.575,22.919,22.919,0,0,1-26.6-23.637l1.675-47.521a23.122,23.122,0,0,0-22.289-23.917l-48.1-1.694a23.167,23.167,0,0,1-21.273-29.763,35.907,35.907,0,0,0,1.355-8.6c.832-23.609-21.577-43.566-50.05-44.57s-52.228,17.33-53.064,40.94a35.982,35.982,0,0,0,.749,8.67,23.171,23.171,0,0,1-23.316,28.192l-48.1-1.693a23.121,23.121,0,0,0-23.918,22.288l-1.666,47.364a23.276,23.276,0,0,0,27.4,24.014,35.961,35.961,0,0,1,8.617-.739c23.613.831,41.943,24.588,40.94,53.065S609.807,1176.731,586.194,1175.9Z",
    transform: "translate(294.112 -849.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M774.442,1051.633v92.979a24.133,24.133,0,0,1-20.887,23.942,24.4,24.4,0,0,1-3.274.219H657.3a24.138,24.138,0,0,1-24.16-24.161v-92.979a24.162,24.162,0,0,1,24.16-24.163h92.98A24.165,24.165,0,0,1,774.442,1051.633Z",
    transform: "translate(322.877 -808.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M681.282,1077.427s-.471,14.553-2.334,21.075L664.2,1108.788l55.5,8.3L706.471,1098.8s-4-19.516-1.9-26.736S681.282,1077.427,681.282,1077.427Z",
    transform: "translate(333.244 -794.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M676.948,1077.034c0-.006,4.389,10.564,12.657,10.332s10.148-9.581,10.148-9.581Z",
    transform: "translate(337.497 -791.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M689.986,1091.71c-5.991-.105-17.017-8.081-17.017-17.96v-15.412c0-3.607,2.515-6.559,5.59-6.559h22.853c3.074,0,5.59,2.952,5.59,6.559v14.542C707,1083.236,696.856,1091.832,689.986,1091.71Z",
    transform: "translate(336.169 -800.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M737.737,1095.734a.04.04,0,0,0-.021-.009,10.057,10.057,0,0,0-2.365-.642v.027a146.273,146.273,0,0,0-17.07-3.256c-.605-.08-1.206-.151-1.8-.221-3.641,4.837-6.556,7.046-9.619,8.584-.68.341-1.364.649-2.067.946q-.914.384-1.873.759a11.5,11.5,0,0,1-2.359-.592c-.442-.159-.875-.34-1.3-.543-5.867-2.77-10.3-9.283-10.3-9.459-.822.084-1.622.176-2.39.273a80.865,80.865,0,0,0-13.687,2.788h-.009c-.428.053-15.542,2.134-38.67,37.084a24.165,24.165,0,0,0,22.742,15.989h92.98a24.146,24.146,0,0,0,22.845-16.272C755.25,1104.608,742.721,1097.576,737.737,1095.734Z",
    transform: "translate(323.232 -787.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M708.635,1071.872l-2.491,3.328s.068-7.3-.329-8.449-1.015-4.645-1.347-5.47-14.951-4.924-27.861,1.2c0,0,.567,5.255-.672,5.719s-.629,8.557-.629,8.557l-2.05-2.313s-3.137-20.956-2.362-23.141,3.244-15.317,29.731-7.521c0,0,8.258-1.75,9.916,3.952S708.635,1071.872,708.635,1071.872Z",
    transform: "translate(335.435 -803.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M682.887,1074.4a16.155,16.155,0,0,0,3.389,1.133,5.421,5.421,0,0,0,3.488-.429,6.5,6.5,0,0,0,2.007-1.879",
    transform: "translate(339.478 -793.166)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M686.111,1065.1a3.172,3.172,0,0,0,3.128,3.344s-1.734,3.389-3.349,3.231",
    transform: "translate(340.48 -795.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M206.42,182.19H193.659l-4.523-4.361a105.157,105.157,0,1,0-11.308,11.308l4.361,4.523V206.42l80.768,80.606,24.069-24.069Zm-96.922,0A72.691,72.691,0,1,1,182.19,109.5,72.594,72.594,0,0,1,109.5,182.19Z",
    transform: "translate(915.641 177.275)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 64.879,
    cy: 64.36,
    rx: 64.879,
    ry: 64.36,
    transform: "translate(960.697 221.299)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentProcessBanner);
export default __webpack_public_path__ + "static/media/recruitment-process-banner.605fcc818866e6b57981081e208e7cce.svg";
export { ForwardRef as ReactComponent };